<template>
  <path
    d="M17 10.5002V7.00018C17 6.45018 16.55 6.00018 16 6.00018H4C3.45 6.00018 3 6.45018 3 7.00018V17.0002C3 17.5502 3.45 18.0002 4 18.0002H16C16.55 18.0002 17 17.5502 17 17.0002V13.5002L19.29 15.7902C19.92 16.4202 21 15.9702 21 15.0802V8.91018C21 8.02018 19.92 7.57018 19.29 8.20018L17 10.5002ZM10.71 14.2902C10.32 14.6802 9.69 14.6802 9.3 14.2902L6.12 11.1102V13.6602H5V9.72018C5 9.44018 5.22 9.22018 5.5 9.22018H9.44V10.3302H6.89L10 13.4302L14.22 9.21018L15 10.0002L10.71 14.2902Z"
  />
</template>
